/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a DNA or RNA sequence to get its GC content, AT content and base composition. FASTA headers, spaces and numbers are ignored, and U is counted as T.`)
};

const es_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia de ADN o ARN para obtener su contenido GC, contenido AT y composición de bases. Las cabeceras FASTA, espacios y números se ignoran, y la U se cuenta como T.`)
};

const de_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine DNA- oder RNA-Sequenz ein, um ihren GC-Gehalt, AT-Gehalt und ihre Basenzusammensetzung zu erhalten. FASTA-Header, Leerzeichen und Zahlen werden ignoriert, und U wird als T gezählt.`)
};

const nl_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een DNA- of RNA-sequentie om het GC-gehalte, AT-gehalte en de basensamenstelling te krijgen. FASTA-headers, spaties en cijfers worden genegeerd, en U wordt geteld als T.`)
};

const fr_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence d'ADN ou d'ARN pour obtenir son contenu GC, son contenu AT et sa composition en bases. Les en-têtes FASTA, espaces et chiffres sont ignorés, et U est compté comme T.`)
};

const it_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza di DNA o RNA per ottenere il suo contenuto GC, il contenuto AT e la composizione in basi. Le intestazioni FASTA, gli spazi e i numeri vengono ignorati, e U viene contata come T.`)
};

const pt_br2_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de DNA ou RNA para obter seu conteúdo GC, conteúdo AT e composição de bases. Cabeçalhos FASTA, espaços e números são ignorados, e U é contado como T.`)
};

const pt_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de ADN ou ARN para obter o seu conteúdo em GC, conteúdo em AT e composição de bases. Cabeçalhos FASTA, espaços e números são ignorados, e U é contado como T.`)
};

const ja_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAまたはRNA配列を貼り付けると、GC含量、AT含量、塩基組成が得られます。FASTAヘッダー、スペース、数字は無視され、UはTとしてカウントされます。`)
};

const zh_gc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 DNA 或 RNA 序列即可获得其 GC 含量、AT 含量和碱基组成。FASTA 标题、空格和数字会被忽略，U 按 T 计数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_intro", locale)
	if (locale === "en") return en_gc_intro(inputs)
	if (locale === "es") return es_gc_intro(inputs)
	if (locale === "de") return de_gc_intro(inputs)
	if (locale === "nl") return nl_gc_intro(inputs)
	if (locale === "fr") return fr_gc_intro(inputs)
	if (locale === "it") return it_gc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_gc_intro(inputs)
	if (locale === "pt") return pt_gc_intro(inputs)
	if (locale === "ja") return ja_gc_intro(inputs)
	return zh_gc_intro(inputs)
};